function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "99.021%",
  id: "icon-toggle_svg__c"
}, React.createElement("stop", {
  stopOpacity: 0,
  offset: "0%"
}), React.createElement("stop", {
  stopOpacity: 0.02,
  offset: "80%"
}), React.createElement("stop", {
  stopOpacity: 0.04,
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "icon-toggle_svg__d"
}, React.createElement("stop", {
  stopColor: "#FFF",
  stopOpacity: 0.12,
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FFF",
  stopOpacity: 0.06,
  offset: "20%"
}), React.createElement("stop", {
  stopColor: "#FFF",
  stopOpacity: 0,
  offset: "100%"
})), React.createElement("filter", {
  x: "-8.8%",
  y: "-8.8%",
  width: "117.5%",
  height: "120%",
  filterUnits: "objectBoundingBox",
  id: "icon-toggle_svg__a"
}, React.createElement("feOffset", {
  dy: 1,
  "in": "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 0.25,
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feComposite", {
  "in": "shadowBlurOuter1",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0",
  "in": "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), React.createElement("feOffset", {
  "in": "SourceAlpha",
  result: "shadowOffsetOuter2"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  "in": "shadowOffsetOuter2",
  result: "shadowBlurOuter2"
}), React.createElement("feComposite", {
  "in": "shadowBlurOuter2",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter2"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0",
  "in": "shadowBlurOuter2",
  result: "shadowMatrixOuter2"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  "in": "shadowMatrixOuter1"
}), React.createElement("feMergeNode", {
  "in": "shadowMatrixOuter2"
}))), React.createElement("circle", {
  id: "icon-toggle_svg__b",
  cx: 10,
  cy: 12,
  r: 10
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  className: "icon-toggle_svg__fi-toggle-icon-slide",
  d: "M38 11c0 3.9-3.1 7-7 7H11c-3.9 0-7-3.1-7-7s3.1-7 7-7h20c3.9 0 7 3.1 7 7z",
  fill: "#C9CDCF"
}), React.createElement("g", {
  className: "icon-toggle_svg__fi-toggle-icon-knob",
  transform: "translate(1 -1)"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#icon-toggle_svg__a)",
  xlinkHref: "#icon-toggle_svg__b"
}), React.createElement("circle", {
  className: "icon-toggle_svg__fi-toggle-icon-circle",
  stroke: "url(#icon-toggle_svg__c)",
  strokeWidth: 0.5,
  strokeLinejoin: "square",
  fill: "#F6F6F7",
  cx: 10,
  cy: 12,
  r: 9.75
}), React.createElement("circle", {
  stroke: "url(#icon-toggle_svg__d)",
  strokeWidth: 0.5,
  strokeLinejoin: "square",
  cx: 10,
  cy: 12,
  r: 9.75
})));

var SvgIconToggle = function SvgIconToggle(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 38 23"
  }, props), _ref, _ref2);
};

export default SvgIconToggle;